<template>
   <div>
    <el-breadcrumb separator-class="el-icon-arrow-right">
      <el-breadcrumb-item>位置：</el-breadcrumb-item>
      <el-breadcrumb-item>订单列表</el-breadcrumb-item>
    </el-breadcrumb>
    <el-card class="conentBox" >
      <el-row class="conentRow">
        <div>
            <span style="margin-top:1rem;">日期：</span>
          <el-col class="conentCol" style="width:28rem;">
            <el-date-picker
              v-model="value1"
              value-format="yyyy-MM-dd"
              type="daterange"
              range-separator="至"
              start-placeholder="开始日期"
              end-placeholder="结束日期">
            </el-date-picker>
          </el-col>
          <el-col class="conentCol" >
              <el-input v-model="data.mobile" placeholder="请输入手机号"></el-input>
          </el-col>
          <el-col class="conentCol">
              <el-input v-model="data.ordernumber" placeholder="请输入订单号"></el-input>
          </el-col>
          <el-col class="conentColSele">
            <el-select
              v-model="data.state"
              placeholder="状态"
              clearable
            >
              <el-option
                v-for="item in typeArr"
                :key="item.value"
                :label="item.label"
                :value="item.value"
              ></el-option>
            </el-select>
          </el-col>
          <el-col class="conentBtn" style="width: auto">
            <el-button type="primary" @click="chaxuns" >查询</el-button>
          </el-col>
        </div>
        <div class="addBtns">
        
        </div>
      </el-row>
      <el-table
        ref="multipleTable"
        :data="tableData"
        tooltip-effect="dark"
        style="width: 100%"
        :header-cell-style="tableHeaderColor"
        :cell-style="cellStyle"
      >
        <el-table-column prop="createtime" label="下单时间"></el-table-column>
        <el-table-column prop="ordernumber" label="订单号"></el-table-column>
        <el-table-column label="订单内容"  width="420">
                <template slot-scope="scope" >
                    <div class="orderContent" >
                      <span >{{scope.row.product_name}}</span>
                      <span>{{scope.row.group_name}}</span>
                      <span>游客名称：{{scope.row.username}}  联系电话：{{scope.row.mobile}}</span>
                      <span>收货地址：{{scope.row.address}}</span>
                    </div>
                </template>
            </el-table-column>
        <el-table-column prop="order_amount" label="订单金额"></el-table-column>
        <el-table-column prop="pay_amount" label="实际付款"></el-table-column>
        <el-table-column prop="postage" label="配送服务"></el-table-column>
        <el-table-column prop="createtime" label="订单状态">
          <template slot-scope="scope">
            <span :class="scope.row.state!='2'?'color_sates':''">{{scope.row.state=='2'?'未发货':scope.row.state=='3'?'已退款':scope.row.state==4?'已发货':scope.row.state==5?'驳回退款':scope.row.state==6?'退款审核':''}}</span>
          </template>
        </el-table-column>
        <el-table-column prop="address" label="操作" width="200"    fixed="right">
          <template slot-scope="scope">
              <span class="peisong" @click="peisong(scope.row)" v-if="scope.row.state=='2'||scope.row.state=='5'||scope.row.state=='6'">配送</span>
              <span style="margin-left:2rem;" class="peisong" @click="shouhou(scope.row)" v-if="scope.row.afte_sale=='需售后'">售后详情</span>
          </template>
        </el-table-column>
      </el-table>
      <!-- 分页开始 -->
      <div class="pagination">
        <span class="demonstration">共{{ total }}条记录，</span>
        <span class="demonstration">当前显示第{{ data.page }}页</span>
        <el-pagination
          background
          layout="prev, pager, next"
          :total="total"
          :page-size="data.page_size"
          :current-page="data.page"
          @current-change="currenchange"
        ></el-pagination>
      </div>
      <!-- 分页结束 -->
    </el-card>
    <el-dialog
      :close-on-click-modal="false"
      title="添加信息"
      :visible.sync="addProDialogVisible"
      :before-close="addProHandleClose"
      width="454px"
      center
    >
      <div class="info_dialogs">
        <el-form :label-position="labelPosition"
          :model="ruleForm"
          ref="ruleForms"
          label-width="78px">
          <el-form-item label="快递名称:"> 
            <el-input placeholder="请输入快递名称" v-model="ruleForm.express"></el-input>
          </el-form-item>
          <el-form-item label="快递单号:"> 
            <el-input placeholder="请输入快递单号" v-model="ruleForm.express_number"></el-input>
          </el-form-item>
        </el-form>
        <div class="dialog_btns">
          <div @click="close">清空</div>
          <div @click="btns">确认添加</div>
        </div>
      </div>
    </el-dialog>
    <el-dialog
      :close-on-click-modal="false"
      title="售后详情"
      :visible.sync="sVisible"
      :before-close="sClose"
      width="574px"
      center
    >
      <div class="info_dialogs">
        <el-form :label-position="labelPosition"
          :model="ruleForm"
          ref="ruleForms"
          label-width="78px">
          <div class="flex">
            <el-form-item label="售后选项:"> 
              <el-input v-model="info.refund_apply=='1'?'仅退款':'退货退款'"  disabled >
              </el-input>
            </el-form-item>
            <el-form-item label="退货单号:"> 
              <el-input v-model="info.refund_express_number"  disabled ></el-input>
            </el-form-item>
          </div>
          <div class="flex">
            <el-form-item label="退款金额:"> 
              <el-input  disabled  v-model="info.refund_money">
              </el-input>
            </el-form-item>
            <el-form-item label="退款原因:"> 
              <el-input v-model="info.refund_reason"  disabled ></el-input>
            </el-form-item>
          </div>
          <el-form-item label="补充描述:"> 
              <el-input v-model="info.refund_remark"  disabled ></el-input>
          </el-form-item>
          <el-form-item label="凭证照片:" > 
              <el-image 
                style="width: 100px; height: 100px"
                :src="info.refund_proof" 
                :preview-src-list="refund_proof">
              </el-image>
          </el-form-item>
        </el-form>
        <div class="dialog_btns">
          <div @click="queren('1')">驳回</div>
          <div @click="queren('2')">确认售后</div>
        </div>
      </div>
    </el-dialog>
   </div>
</template>
<script>
import { getItemOrderList , addExpressInfo , afterSaleDetail , afterSaleRefund }  from '@/request/scenic.js'
import { Message } from 'element-ui'
export default {
  data(){
    return{
      refund_proof:[],
      typeArr:[
        {
          value:'0',
          label:'全部'
        },
        {
          value:'2',
          label:'未发货'
        },
        {
          value:'3',
          label:'已退款'
        },
        {
          value:'4',
          label:'已发货'
        },
      ],
      sVisible:false,
      ruleForm:{
        token: window.sessionStorage.getItem("Token"),
        orderid:'',
        express:'',
        express_number:''
      },
      addProDialogVisible:false,
      total:0,
      data:{
        page:1,
        page_size:10,
        token: window.sessionStorage.getItem("Token"),
        ordernumber:"",
        mobile:'',
        state:'0',
        endtime:'',
        starttime:''
      },
      tableData:[],
      info:'',
      orderid:'',
      value1:''
    }
  },
  created(){
    this.getList()
  },
  methods:{
    chaxuns(){
      if(this.value1){
        this.data.starttime = this.value1[0]
        this.data.endtime = this.value1[1]
      }else{
        this.data.starttime = ''
        this.data.endtime = ''
      }
      this.data.page = 1
      this.getList()
    },
    queren(e){
      let data = {
        token: window.sessionStorage.getItem("Token"),
        orderid:this.orderid,
        type:e
      }
      afterSaleRefund(data).then(res=>{
        if(res.data.rcode==200){
          if(e==1){
            Message.success('驳回成功')
          }else{
            Message.success('确认售后成功')
          }
          this.getList()
          this.sVisible = false
        }else{
          Message.error(res.data.msg)
        }
      })
    },
    shouhou(row){
      this.orderid = row.id
      this.shouDetai(row)
      this.sVisible = true
    },
    shouDetai(row){
      let data = {
        token: window.sessionStorage.getItem("Token"),
        orderid:row.id
      }
      afterSaleDetail(data).then(res=>{
        if(res.data.rcode==200){
          this.info = res.data.result
          this.refund_proof = [res.data.result.refund_proof]
        }
      })
    },
    sClose(){
      this.sVisible = false
    },
    close(){
      this.ruleForm.express = ''
      this.ruleForm.express_number = ''
    },
    btns(){
      if( this.ruleForm.express == ''){
        Message.error('请输入快递名字')
        return false
      }
      if( this.ruleForm.express_number == ''){
        Message.error('请输入快递单号')
        return false
      }
      addExpressInfo(this.ruleForm).then(res=>{
        if(res.data.rcode==200){
          Message.success('添加成功')
          this.addProDialogVisible = false
          this.ruleForm={
            token: window.sessionStorage.getItem("Token"),
            orderid:'',
            express:'',
            express_number:''
          }
          this.getList()
        }else{
          Message.error(res.data.msg)
        }
      })
    },
    addProHandleClose(){
      this.addProDialogVisible = false
      this.ruleForm={
        token: window.sessionStorage.getItem("Token"),
        orderid:'',
        express:'',
        express_number:''
      }
    },
    peisong(row){
      this.ruleForm.orderid = row.id
      this.addProDialogVisible = true
    },
    currenchange(e){
      this.data.page = e
      this.getList()
    },
    getList(){
      getItemOrderList(this.data).then(res=>{
        if(res.data.rcode==200){
          this.tableData = res.data.result.data
          this.total = res.data.result.total
        }
      })
    },  
     // 表头设置
     tableHeaderColor({ row, column, rowIndex, columnIndex }) {
      return this.utils.tableHeaderColor({
        row,
        column,
        rowIndex,
        columnIndex,
      });
    },
    cellStyle({ row, rowIndex }) {
      return this.utils.cellStyle({
        row,
        rowIndex,
      });
    },
  }
}
</script>
<style lang="less" scoped>
.info_dialogs {
  padding: 2rem;
  box-sizing: border-box;
  border-top: 1px solid #e5e5ea;
  ::v-deep .el-select{
    width: 100%;
  }
  .fengmian{
    display: flex;
    >span{
      margin-left: 2rem;
      color: #FF4D4F;
      font-size: 1.4rem;
      line-height: 1.4rem;
      margin-top: auto;
      display: block;
    }
  }
  .avatar-uploader{
    width: 23rem;
    height: 13rem;
    border-radius: 0.8rem;
    border: 1px solid #E5E5EA;
    img{
      width: 100%;
      height: 100%;
    }
    ::v-deep .el-upload{
      width: 100%;
      height: 100%;
      display: flex;
      justify-content: center;
      align-items: center;
      .el-icon-plus{
        font-size: 2.8rem;
      }
    }
  }
}
  .dialog_btns{
  display: flex;
  align-items: center;
  justify-content: center;
  margin-top: 4rem;
  >div{
    width: 10rem;
    height: 4rem;
    color: #fff;
    cursor: pointer;
    display: flex;
    justify-content: center;
    align-items: center;
    border-radius: 0.4rem;
    &:nth-child(1){
      margin-right: 2rem;
      background: #D9D9D9;
    }
    &:nth-child(2){
      background: #246deb;
    }
  }
}
// 分页
.pagination {
  display: flex;
  justify-content: center;
  align-items: center;
  height: 32px;
  margin: 42px auto;
  position: relative;
  span {
    font-family: ".PingFang SC";
    font-style: normal;
    font-weight: 400;
    font-size: 14px;
    color: #000000;
  }
}
.conentBox {
  margin-top: 17px;
  .conentRow {
    margin: 20px 0;
    display: flex;
    flex-wrap: wrap;
    justify-content: space-between;
    > div:nth-child(1) {
      // width: 50%;
      display: flex;
      flex-wrap: wrap;
      justify-content: space-between;
      .conentCol {
        width: 22rem;
        position: relative;
        margin-right: 10px;
        // margin-bottom: 10px;
        /deep/.el-date-editor {
          width: 100%;
        }
      }
      .conentColSele {
        margin-right: 10px;
        margin-left:2rem;
        width: 22rem;
        position: relative;
        /deep/.el-select {
          width: 100%;
        }
      }
      .conentBtn {
        margin-bottom: 10px;
        // width: 120px;
        .el-button {
          width: 100px;
          // width: 84%;
          background: #246deb;
          border-radius: 4px;
          font-family: ".PingFang SC";
          font-style: normal;
          font-weight: 400;
          font-size: 14px;
          color: #ffffff;
        }
      }
    }
    > div:nth-child(2) {
      // width: 50%;
      display: flex;
      justify-content: flex-end;
      margin-bottom: 10px;
      margin-left: auto;
      .scenicBtnDel {
        .el-button {
          width: 92px;
          background: #ffffff;
          border: 1px solid #ff4d4f;
          border-radius: 4px;
          font-family: ".PingFang SC";
          font-style: normal;
          font-weight: 400;
          font-size: 14px;
          color: #ff4d4f;
          box-sizing: border-box;
        }
      }
      .scenicBtnPx {
        margin: 0 20px;
        .el-button {
          background: #ffffff;
          border: 1px solid #246deb;
          border-radius: 4px;
          font-family: ".PingFang SC";
          font-style: normal;
          font-weight: 400;
          font-size: 14px;
          /* identical to box height */
          box-sizing: border-box;
          color: #246deb;
        }
      }
      .scenicBtn {
        .el-button {
          width: 120px;
          background: #ffffff;
          border: 1px solid #246deb;
          border-radius: 4px;
          font-family: ".PingFang SC";
          font-style: normal;
          font-weight: 400;
          font-size: 14px;
          box-sizing: border-box;
          color: #246deb;
        }
      }
    }
  }
}
.peisong{
  color: #246DEB;
  font-size: 1.4rem;
  cursor: pointer;
}
.color_sates{
  color: #FF4D4F;
}
.flex{
  display: flex;
}
.orderContent{
  display: flex;
  flex-direction: column;
}

.orderContent span{
  text-align: left;
  color: #000000;
  font-size: 1.4rem;
  height: 2.6rem;

  &:nth-child(1){
    color: #468BC8;
    cursor: pointer;
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
  }
}
::v-deep .cell{
  text-align: left;
}
</style>